<template>
  <div style="height:100%;display:flex">
    <div class="pic" :style="{backgroundImage:'url('+basicInfo.backgroundUrl+')'}">
      <div class="pro-title">{{basicInfo.sysName}}</div>
      <div class="pro-des">{{basicInfo.description}}</div>
    </div>
    <div class="login-content">
      <div class="login-logo">
        <img :src="basicInfo.logo" alt="">
        <span>{{basicInfo.logoName}}</span>
      </div>
      <img class="colorful" src="../assets/img/colorful.png" alt="">
      <!-- <div @click="ifHaveAccount" class="no-account">没有账号，去注册</div> -->
      <div class="main">
        <div style="color: rgba(0, 0, 0, 1);font-size: 26px;font-weight:bold">
          登录
        </div>
        <div v-if="hasAccount" style="margin-top:20px">
          <div v-if = wechatLogin
            id="formLogin"
            class="user-layout-login"
            ref="formLogin"
          >
              <div class="login-head">
                <div class="login-way">
                  <div @click="chooseTab(1)" :class="{'active':currentTab==1}">账号登录</div>
                  <span class="line line1" v-if="currentTab==1"></span>
                </div>
                <div class="login-way">
                  <div @click="chooseTab(2)" :class="{'active':currentTab==2}">手机号登录</div>
                  <span class="line line2" v-if="currentTab==2"></span>
                </div>
              </div>
              <div style="clear:both"></div>
              <div style="margin-top:54px">
                <div v-if="currentTab==1">
                  <div style="margin-bottom:20px">
                    <a-input
                      v-model="accountNumber"
                      size="large"
                      type="text"
                      placeholder="手机号"
                      maxlength="11"
                      @input="loginInputPhone"
                      style="height:52px;background:rgba(188, 202, 214, 0.2);border:none"
                    >
                    </a-input>
                  </div>
                  <div>
                    <a-input
                      v-model="password"
                      size="large"
                      type="password"
                      placeholder="密码"
                      style="margin-bottom:12px;height:52px;background:rgba(188, 202, 214, 0.2);border:none"
                    >
                    </a-input>
                  </div>
                  <div style="text-align:right;margin-bottom:12px;">
                    <a-checkbox @change="rememberPassword" :default-checked='ifRememberPassword' style="font-size:14px;color:rgba(139, 152, 167, 1)">记住密码</a-checkbox>
                  </div>
                </div>
                <div v-if="currentTab==2">
                  <div>
                    <a-input style="margin-bottom:20px;background:rgba(188, 202, 214, 0.2);height:52px;border:none" size="large" type="text" placeholder="请输入用户名" v-model="phoneNum">
                    </a-input>
                  </div>
                  <a-row :gutter="16" style="margin-bottom:20px">
                    <a-col class="gutter-row" :span="16">
                      <div>
                        <a-input style="background:rgba(188, 202, 214, 0.2);height:52px;border:none" size="large" type="text" v-model="verificationCode" placeholder="请输入验证码">
                        </a-input>
                      </div>
                    </a-col>
                    <a-col class="gutter-row" :span="8">
                      <a-button
                        @click="getMsg"
                        class="get-captcha"
                        tabindex="-1"
                      >获取验证码</a-button>
                    </a-col>
                  </a-row>
                </div>
              </div>
              
            <div style="margin-top:12px">
              <a-button @click="loginIn"
                size="large"
                type="primary"
                htmlType="submit"
                class="login-button"
                style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);font-size:18px;height:52px"
              >登录</a-button>
            </div>
          </div>
          <div v-if = !wechatLogin class="wechat-login">
            <img src="../assets/img/erweima.png" alt="">
            <div class="wechat-login-text">微信扫码登陆</div>
            <div class="back-login">
              <span @click="backLogin" style="cursor:pointer">
                <a-icon type="rollback" />
                <span>返回</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div style="position:absolute;bottom:20px;width:100%">
        <div style="font-size:12px;color:rgba(204, 204, 204, 1);text-align:center">
          <a style="color:rgba(204, 204, 204, 1);" target="_blank" href="https://beian.miit.gov.cn/">{{ basicInfo.support }}</a>
        </div>
        <div style="color:rgba(204, 204, 204, 1);font-size:12px;text-align:center">
          <span style="cursor:pointer" @click="showPicModal('1','全国呼叫中心增值电信业务经营许可证')">全国呼叫中心增值电信业务经营许可证B2-20160586</span> | 
          <span style="cursor:pointer" @click="showPicModal('2','95电信网码号资源许可证')">95电信网码号资源许可证952112</span> | 
          <span style="cursor:pointer" @click="showPicModal('3','106短信码号资源许可证')">106短信码号资源许可证10681104</span> | 
          <span style="cursor:pointer" @click="showPicModal('4','全国多方通信许可证')">全国多方通信许可证B2-20160586</span>
        </div>
      </div>
    </div>
    <a-modal
      :title="picName"
      :visible="showPicVisiable"
      :footer="null"
      width='540px'
      @cancel="offShowPic"
    >
     <img v-if="currentImg==1" style="width:100%" src='~@/assets/img/certificates/pic1.jpg' alt="">
     <img v-if="currentImg==2" style="width:100%" src='~@/assets/img/certificates/pic2.jpg' alt="">
     <img v-if="currentImg==3" style="width:100%" src='~@/assets/img/certificates/pic3.jpg' alt="">
     <img v-if="currentImg==4" style="width:100%" src='~@/assets/img/certificates/pic4.jpg' alt="">
    </a-modal>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
  name: 'Login',
  props: {
    msg: String,
  },
  data() {
    return {
      wechatLogin: true,
      currentTab: 1,
      accountNumber: null,
      password: null,
      phoneNum:null,
      verificationCode: null,
      hasAccount: true,
      ifRememberPassword: true,
      title: '登录',
      showPicVisiable: false,
      picName:'',
      currentImg: '',
      basicInfo: '',
      pageTitle: '',
      faviconIcon: ''
    };
  },
  methods: {
    /*--------是否微信登陆---------*/
    backLogin(){
      this.wechatLogin = !this.wechatLogin
    },
    /*--------是否记住密码---------*/
    rememberPassword(e) {
      this.ifRememberPassword = e.target.checked
    },
    /*--------账号密码登陆&手机验证码登录---------*/
    loginIn () {
      if(this.currentTab == 1){
        this.axios.post('/api/login/phone/password', {
          phone: this.accountNumber,
          password: this.password
        })
        .then(response=> {
          if(response.data.code == 0){
            if(this.ifRememberPassword){
              let userName = CryptoJS.AES.encrypt(this.accountNumber+"@、"+this.password,"projectInfoName").toString();
              this.$cookie.set('abge', userName, 7);
            }
            this.sessionData('set','token',response.data.data.token);
            this.resetSetItem('avatar',response.data.data.avatar);
            this.resetSetItem('userName',response.data.data.name);
            this.$router.push("/MyProject")
          }else{
            this.$message.error(response.data.message)
          }
        })
        .catch(error=> {
          console.log(error);
        });
      }else{
        this.axios.post('/api/login/phone/verifyCode', {
          phone: this.phoneNum,
          verifyCode: this.verificationCode
        })
        .then(response=> {
          if(response.data.code == 0){
            this.sessionData('set','token',response.data.data.token);
            this.resetSetItem('avatar',response.data.data.avatar);
            this.resetSetItem('userName',response.data.data.name);
            this.$router.push("/MyProject")
          }else{
            this.$message.error(response.data.message)
          }
        })
        .catch(error=> {
          console.log(error);
        });
      }
    },
    /*--------获取手机短信验证码---------*/
    getMsg(){
      this.axios.post('/api/verifyCode', {
        phone: this.phoneNum,
        type: '1'
      })
      .then(response=> {
        if(response.data.code == 0){
          this.success('短信发送成功')
        }else{
          this.$message.error(response.data.message)
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    /*--------切换tab---------*/
    chooseTab(type) {
      this.currentTab = type
    },
    ifHaveAccount() {
      window.open("http://cloud.ixiaowen.net/#/Login?registerValue=true&appId=1", "_self");
    },
    loginInputPhone(e){
      let filtered = e.target.value.replace(/^0|[^\d]/g, '');  
      if(this.accountNumber != filtered){
          this.accountNumber = filtered;
      }
    },
    offShowPic() {
      this.showPicVisiable = false
    },
    showPicModal(path,name) {
      this.showPicVisiable = true
      this.picName = name
      this.currentImg = path
    },
    queryBasicInfo() {
      let host = window.location.host
      this.axios(
        {
          method:'get',
          url:'/api/login/loginInfo', 
          params: {
            hostName: host,
          }
      })
      .then(response=> {
        if(response.data.code == 0){
          this.basicInfo = response.data.data
          this.pageTitle = response.data.data.sysName
          this.faviconIcon = response.data.data.titleLogo
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    }
  },
  mounted: function() {
    if(this.$cookie.get('abge')){
      let userName = this.$cookie.get('abge')
      let bytes = CryptoJS.AES.decrypt(userName, "projectInfoName");
      this.accountNumber = (bytes.toString(CryptoJS.enc.Utf8)).split("@、")[0];
      this.password = (bytes.toString(CryptoJS.enc.Utf8)).split("@、")[1];
    }
    this.queryBasicInfo()
  },
  updated() {
    document.title = this.pageTitle;
    const favicon = document.getElementById('dynamic-favicon');
    favicon.href = this.faviconIcon
  }
}
</script>

<style lang="less" scoped>
  .ant-form-item{
    margin: 0px !important;
  }
  .user-layout-login {
    label {
      font-size: 14px;
    }
    .get-captcha {
      display: block;
      width: 100%;
      height: 52px;
      border-color: #eee;
      line-height: 50px;
      padding-left: 12px;
      font-size: 14px;
    }
    .forge-password {
      font-size: 14px;
    }
    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }
    .user-login-other {
      text-align: center;
      margin-top: 16px;
      font-size: 13px;
      color:rgba(139, 152, 167, 1);
      span{
        cursor: pointer;
      }
    }
  }
  .pic{
    width: 640px;
    height: 100%;
    // background: url('../assets/img/login-bg.jpg');
    padding: 196px 0 0 120px;
    .pro-title{
      color: rgba(18, 18, 18, 1);
      font-size: 40px;
      letter-spacing: 1px;
    }
    .pro-des{
      color: rgba(44, 64, 90, 1);
      font-size: 16px;
      margin-top: 32px;
    }
  }
  .login-content{
    flex: 1;
    position: relative;
    background: #fff;
    .colorful{
      position: absolute;
      right: 0;
      top: 0;
      width: 360px;
    }
    .no-account{
      color:rgba(0, 0, 0, 1);
      font-size: 14px;
      cursor: pointer;
      position: absolute;
      right: 70px;
      top: 34px;
      font-weight: bold;
      font-size: 15px;
    }
    .login-logo{
      position: absolute;
      left: 60px;
      top: 20px;
      img{
        width: 48px;
        float: left;
        margin-right: 8px;
      }
      span{
        color: rgba(0, 0, 0, 1);
        font-size: 20px;
        float: left;
        font-weight: bold;
        margin-top: 8px;
      }
    }
    .main{
      min-width: 260px;
      width: 320px;
      // height: 450px;
      margin: 0 auto 0;
      position: absolute;
      top:50%;
      left:50%;
      margin-top: -260px;
      margin-left:-130px;
      .wechat-login{
        text-align: center;
        img{
          display: block;
          margin: 30px auto 0;
          width: 205px;
        }
        .wechat-login-text{
          margin: 40px auto 8px;
        }
        i{
          margin-right: 5px;
        }
        .backLogin{
          cursor: pointer;
        }
      }
      .login-head{
        .login-way{
          display: inline-block;
          margin-right: 32px;
          color: rgba(0, 0, 0, 1);
          font-size: 18px;
          cursor: pointer;
          text-align: center;
          position: relative;
          text-align: center;
          // float: left;
        }
        div.active{
          color: #22D7BB;
        }
        .line{
          display: inline-block;
          width: 32px;
          height: 4px;
          background: rgba(34, 215, 187, 1);
          text-align: center;
          float: left;
          margin-top: 4px;
          position: absolute;
          left: 50%;
        }
        .line1{
          margin-left: -16px;
        }
        .line2{
          margin-left: -16px;
        }
      }
    }
  }
  .ant-input:focus {
    border: none;
    box-shadow: none;
  }
</style>
